import { render, staticRenderFns } from "./FtaInfoPie.vue?vue&type=template&id=b650a968&scoped=true"
import script from "./FtaInfoPie.vue?vue&type=script&lang=js"
export * from "./FtaInfoPie.vue?vue&type=script&lang=js"
import style0 from "./FtaInfoPie.vue?vue&type=style&index=0&id=b650a968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b650a968",
  null
  
)

export default component.exports